import msp1 from "../img/MissionStatementImg/MissionStatementPic1.avif";
import msp2 from "../img/MissionStatementImg/MissionStatementPic2.avif";
import msp3 from "../img/MissionStatementImg/MissionStatementPic3.avif";
import msp4 from "../img/MissionStatementImg/MissionStatementPic4.avif";
import msp5 from "../img/MissionStatementImg/MissionStatementPic5.avif";

export const msSlides = [
    {
        src: msp1,
        title: "test1",
        description: "desc1",
    },
    {
        src: msp2,
        title: "test2",
        description: "desc2",
    },
    {
        src: msp3,
        title: "test3",
        description: "desc3",
    },
    {
        src: msp4,
        title: "test4",
        description: "desc4",
    },
    {
        src: msp5,
        title: "test5",
        description: "desc5",
    }


]